/*
 * /people (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"

export const Route = createFileRoute("/people/")({
	component: PeoplePage,
})

function PeoplePage() {
	// const peopleTrackingEnabled =
	// 	user.flags.psychology?.peopleTrackingEnabled || false

	// // Pre-fetch data if tracking is enabled
	// let allPeople: PsychologyPerson[] = []

	// if (peopleTrackingEnabled) {
	// 	try {
	// 		const result = await getAllPeopleAction({ userId: user.id })
	// 		allPeople = result.data || []
	// 	} catch (error) {
	// 		console.error("Error pre-fetching people data:", error)
	// 	}
	// }

	// // Separate confirmed and unconfirmed people on the client side
	// const confirmedPeople = allPeople.filter((person) => person.userConfirmed)
	// const unconfirmedPeople = allPeople.filter((person) => !person.userConfirmed)

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"People"}
					left={{
						href: "/dashboard",
						label: "dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className="space-y-6">
					TODO
					{/* <PeopleTrackingToggle
						userId={user.id}
						initialEnabled={peopleTrackingEnabled}
					/>

					{peopleTrackingEnabled && (
						<PeopleList
							confirmedPeople={confirmedPeople}
							unconfirmedPeople={unconfirmedPeople}
							userId={user.id}
						/>
					)} */}
				</div>
			</Container>
		</Page>
	)
}
